/*
 * @Description:
 * @Date: 2024-11-05 09:46:10
 */
/*
 * @Description: API注册(公共接口)
 * @Date: 2022-03-14 19:12:05
 */
import http from '@/utils/http/axios';
import { jsonConfig, wwwConfig } from '@/utils/http/axios/content-type';
import { imageJsonTranslator } from './translators';

enum Api {
  upload = '/back-end/file/upload', // 文件上传
  imageJson = '/back-end/api/v1/userSignIn/verification/imageJson', // 滑块验证
  static = '/back-end/api/v1/userSignIn/verification/imageJson', // 静态资源
  entpLoginUser = '/back-end/api/v1/entp/entpLoginUser', // 获取企业信息
  lastProtocol = '/back-end/protocol/lastProtocol', // 协议管理-获取注册协议
  lastPolicy = '/back-end/protocol/lastPolicy', // 隐私协议
  signContract = '/front-end/ht/contract/signingContractAll', // 合同签署
  getUserUnsignedContract = '/front-end/ht/contract/loginCheckContract',
  rnvRedirectUrl = '/front-end/real/api/v1/rnvRedirectUrl', // 获取【前往实名认证】url
  downloadExcelTemplate = '/front-end/api/v1/download/excel/template', // 下载导入模板
  entpBankBuild = '/back-end/api/v1/entp/entpBankBuild', // 企业维护开户行信息
  zsStatus = '/front-end/zs/config/zsStatus' // 查询招商状态（权限）
}

export const uploadApi = params =>
  http.uploadFile(
    {
      url: Api.upload,
      method: 'POST',
      params
    },
    {
      // yapi: 1271,
      // isParseToJson: true
    }
  );
export const imageJson = async params => {
  const resp = await http.request(
    {
      url: Api.imageJson,
      method: 'POST',
      params: { type: 'slide', ...params } // 写死参数
    },
    { ...wwwConfig }
  );
  return imageJsonTranslator(resp);
};

/**
 * 企业信息弹框
 */
export const entpLoginUser = (params?) =>
  http.request(
    {
      url: Api.entpLoginUser,
      method: 'POST',
      params
    },
    { ...wwwConfig }
  );
export const lastProtocol = async () =>
  http.request(
    {
      url: Api.lastProtocol,
      method: 'GET'
    },
    { ...wwwConfig }
  );
export const lastPolicy = async () =>
  http.request(
    {
      url: Api.lastPolicy,
      method: 'GET'
    },
    { ...wwwConfig }
  );

export const signContract = async (params?) =>
  http.request(
    {
      url: Api.signContract,
      method: 'POST',
      params
    },
    {
      ...jsonConfig
    }
  );

export const getUserUnsignedContract = async (params?) =>
  http.request(
    {
      url: Api.getUserUnsignedContract,
      method: 'POST',
      params
    },
    {
      ...wwwConfig
    }
  );

export const rnvRedirectUrl = async (params: {
  entpName: string; // 企业名称
  entpCertPic: string; // 营业执照URL
  entpCertType: 1 | 2; // 企业证件编码类型1统一社会信用码2工商注册号
  entpCertNo: string; // 企业证件号
  legalName: string; // 企业法人姓名
  contactor: string; // 联系人姓名
  contactorPhone: string; // 联系人手机号
  contactId: string; // 联系人身份证号
  redirectUrl: string; // E签宝实名完成前端跳转页面
  deptId: number; // 部门id
  isSkip: 0 | 1;
  entityType: 1 | 2 | 3;
}) =>
  http.request({
    url: Api.rnvRedirectUrl,
    method: 'POST',
    params
  });

/**
 * 下载导入模板
 */
export const downloadExcelTemplate = (params: { excelGroupCode: string }) =>
  http.download({
    url: Api.downloadExcelTemplate + '/' + params.excelGroupCode,
    method: 'GET'
  });

/**
 *
 * @param params 企业维护开户行信息
 * @returns
 */
export const entpBankBuild = async (params?) =>
  http.request({
    url: Api.entpBankBuild,
    method: 'POST',
    params
  });

/**
 *
 * @param params 查询招商状态（权限）
 * @returns
 */
export const zsManageIsHidden = async (params?) =>
  http.request({
    url: Api.zsStatus,
    method: 'GET',
    params
  });
